var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHumlegardenFastigheterBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 926.5 109.9",
    width: 266,
    height: 32,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n.svg-logo{fill:#000000;stroke:#000000;stroke-miterlimit:10;}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Humleg\xE5rden Fastigheter") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "svg-logo",
    d: "M913.1,85.9l-28.5-43.1c-0.2-0.3-0.7-1.2-1.4-2.6c-0.5-0.8-0.7-1.3-0.8-1.4c-0.4-0.7-0.7-1.5-0.9-2.3v48.8h-12.1V18.7H884l28,43.8c0.1,0.2,0.4,0.7,0.7,1.4c0.3,0.7,0.5,1.1,0.6,1.3l0.6,1.7l0.6,1.3V18.7h12v67.2H913.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "svg-logo",
    d: "M142,81.8c-4.8,3.3-10.5,4.8-18.8,4.8s-13.8-1.4-18.9-4.8c-6.9-4.7-9.1-10.3-9.1-22.5V18.7h12.6V60c0,9.9,5.1,14.8,15.7,14.8c9.7,0,14.8-5.2,14.8-14.8V18.7h12.7v40.6C151.1,71.5,148.9,76.9,142,81.8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "svg-logo",
    d: "M300,85.3V18.7h12.7v55.8H340v10.8H300z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "svg-logo",
    d: "M371.5,85.3V18.7H412v10.8h-27.8v16.4H407v10.8h-22.8v17.7h29.2v10.8H371.5z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "svg-logo",
    d: "M494.7,84.4c-5.5,1.5-11.1,2.2-16.8,2.2c-22.1,0-37.4-14.1-37.4-34.7c-0.2-9.7,3.8-18.9,11-25.4c6.9-6.3,14.5-8.9,26-8.9c4.7,0,9.4,0.5,13.9,1.5c3.4,0.9,6.7,2,9.9,3.5l-3,10.6c-2.4-0.9-4.2-1.5-5.5-1.9c-4.4-1.5-9-2.4-13.7-2.4c-14.9,0-25.3,9.2-25.3,22.4c0,13.6,11.4,24,26.2,24c3,0,5.9-0.5,8.7-1.4V55.5h12.7v27.2C498.5,83.5,496.3,84.1,494.7,84.4z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "svg-logo",
    d: "M793.1,85.3V18.7h40.5v10.8h-27.8v16.4h22.8v10.8h-22.8v17.7h29.2v10.8H793.1z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "svg-logo",
    d: "M566.3,23.2c3.2-2.4,5.1-6.3,5-10.3c0-7.1-5.7-12.8-12.8-12.8c-7.1,0-12.8,5.7-12.8,12.8c0.1,4.3,2.3,8.2,5.9,10.5l-22.4,61.9h13.3l5.5-16.5h22.3l5.3,16.4h13.3L566.3,23.2z M558.6,7.3c3,0.1,5.4,2.5,5.4,5.6c0.1,2.9-2.1,5.3-5,5.4c-3.1,0.1-5.7-2.3-5.8-5.4C553,9.8,555.5,7.3,558.6,7.3z M551,58.1l8-25.1l8.1,25.1H551z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "svg-logo",
    d: "M251.4,85.3l-6.4-48.2l-15.3,48.2h-11.4l-14.1-48.6l-6.4,48.6h-12.6l8.9-66.6h16.4l14,50.1l15.1-50.1h15.4l9,66.6L251.4,85.3z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "svg-logo",
    d: "M747.6,51.9c0,14.2-8.5,22.2-23.6,22.2h-10.1V29.9H724c7.3,0,12.4,1.3,15.9,3.9C744.7,37.4,747.6,44.3,747.6,51.9z M761.3,51.8c0-8.6-3.2-16.9-9-23.3c-6.5-7-14.4-9.8-27-9.8h-24.7v66.6h24.6c12,0,20.8-3.2,26.9-9.8C758.1,69,761.4,60.6,761.3,51.8z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "svg-logo",
    d: "M711,103.9c-45.7,5.5-44.1-35.3-64-47.8c2.1-0.5,4.2-1.2,6.1-2.2c5.7-3,9.4-8.8,9.9-15.2c0.8-10.9-9-20-20.3-20h-25.1v66.6h12.7V58.6c21.9,0,17.8,63.6,81.3,49.1L711,103.9z M630.3,47.7V29.5h10.6c5.1,0,9.3,4.1,9.3,9.2c-0.1,5.1-4.3,9.1-9.3,9.1H630.3z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "svg-logo",
    d: "M44.6,85.3V56.7H12.1v28.5H0V18.7h12.1v26.6h32.5V18.7h12.7v66.6H44.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHumlegardenFastigheterBlack);
export default __webpack_public_path__ + "static/media/humlegarden-fastigheter_black.1e7fb7136c8d8f68a7a20eceaa0bc3b2.svg";
export { ForwardRef as ReactComponent };